import Component from "@tunnel-components/@sharded/@widgets/select/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Utils from "@Cyclope-Utils/index";
import * as Lodash from "lodash";
import * as i18next from "i18next";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onMouseEnter
 * @name onMouseLeave
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 100 millisecondes
  public debouceMouseEnter = Lodash.debounce(() => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ isVisible: true }));
  }, 100);
  //  faire cette action toute les 100 millisecondes
  public debouceMouseLeave = Lodash.debounce(() => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ isVisible: false }));
  }, 100);
  //  faire cette action toute les 100 millisecondes
  public debouceGetValue = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({
      // isVisible:false,
      identifiant: event.target.id,
      selectedValue: event.target.textContent.trim(),
    }));
  }, 100);

  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     */
    this.state = {
      isVisible: false,
      selectedOptions: props.selectedOptions, // initialisation des datas
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onGetValue = this.onGetValue.bind(this);
    this.onSearchValue = this.onSearchValue.bind(this);
  }
  /**
   * fermeture ou ouverture du calandrier
   * @method onMouseEnter
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onMouseEnter = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debouceMouseEnter();
  };
  /**
   * fermeture ou ouverture du calandrier
   * @method onMouseLeave
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onMouseLeave = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();

    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debouceMouseLeave();
  };
  /**
   * Changement des états des inputs
   * @method onSearchValue
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onSearchValue = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();

    {
      /** vérification de l'existence de l'élement  */
    }
    if (!Lodash.isUndefined(this.props.selectedOptions)) {
      /**
       * @constant
       * @name selectedOptions
       * @type any[]
       */
      let selectedOptions: any[] = []; // Creation d'un nouveau tableau
      const selectedItem: any = this.props.selectedOptions; // remplir le tableau

      if (this.props.camera) {
        {
          /** filtre du tableau des datas */
        }
        selectedOptions = Utils.transformObjectToArray(selectedItem).filter(
          (elem: any) =>
            elem.code
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) !== -1
        );
        {
          /** Empêcher la mutation du state */
        }
      } else if (this.props.incident) {
        {
          /** filtre du tableau des datas */
        }
        selectedOptions = Utils.transformObjectToArray(selectedItem).filter(
          (elem: any) =>
            i18next
              .t(`${elem.label}`)
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) !== -1
        );
      } else if (this.props.section) {
        {
          /** filtre du tableau des datas */
        }
        selectedOptions = Utils.transformObjectToArray(selectedItem).filter(
          (elem: any) =>
            elem.name
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) !== -1
        );
      } else if (this.props.cameraAndSection) {
        {
          /** filtre du tableau des datas */
        }
        selectedOptions = Utils.transformObjectToArray(selectedItem).filter(
          (elem: any) =>
            elem.code
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) !== -1
        );
      } else if (this.props.cameraString) {
        {
          /** filtre du tableau des datas */
        }
        selectedOptions = selectedItem.filter(
          (elem: any) =>
            elem.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
        );
      } else if (this.props.vue) {
        {
          /** filtre du tableau des datas */
        }
        selectedOptions = selectedItem.filter(
          (elem: any) =>
            elem.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
        );
      }

      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({
        identifiant: "eudes",
        selectedOptions,
        selectedValue: event.target.value.trim(),
      }));
    }
  };
  /**
   * Changement des etats des inputs
   * @method onGetValue
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onGetValue = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacées dans le temps
     */
    this.debouceGetValue(event);
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.selectedOptions !== this.props.selectedOptions) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        selectedOptions: Utils.transformObjectToArray(
          nextProps.selectedOptions
        ),
      }));
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    if (prevState.identifiant !== this.state.identifiant) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        identifiant: this.state.identifiant,
      }));
      {
        /** vérification de l'existence de la variable */
      }
      if (!Lodash.isEqual(this.state.identifiant, "eudes")) {
        {
          /** MAJ des props du parent */
        }
        this.props.onGetIdentifiantItem(this.state.identifiant);
      } else {
        {
          /** MAJ des props du parent */
        }
        this.props.onGetIdentifiantItem("eudes");
      }
    } else if (prevProps.selectedValueProps !== this.props.selectedValueProps) {
      {
        /** vérification de l'existence de la variable */
      }
      if (Lodash.isEmpty(this.props.selectedValueProps)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ selectedValue: "" }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      identifiant: "eudes",
      isVisible: false,
      selectedValue: "",
    }));

    // Stopper l'action une fois le component détruit
    this.debouceMouseEnter.cancel();
    // Stopper l'action une fois le component détruit
    this.debouceMouseLeave.cancel();
    // Stopper l'action une fois le component détruit
    this.debouceGetValue.cancel();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onMouseLeave={this.onMouseLeave}
        onMouseEnter={this.onMouseEnter}
        onGetValue={this.onGetValue}
        onSearchValue={this.onSearchValue}
        {...this.props}
        {...this.state}
      />
    );
  }
}

{
  /** exporter le HOC : connect */
}
export default connect(null, {})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/select/container.tsx